export default __webpack_public_path__ + "fdbb89054c18652d0f8b438d6791fdf1.png";